import { ReactNode } from 'react';

interface FilterGroup {
    title: string;
    children: ReactNode;
}

interface FilterSidebarProps {
    filterGroups?: FilterGroup[];
    children?: ReactNode;
    footerData?: {
        totalRecords?: number;
        lastUpdate?: string;
        selectedFilters?: number;
        apiInfo?: {
            name: string;
            version: string;
            environment: string;
        };
    };
    showFooter?: boolean;
    className?: string;
}

const FilterSidebar = ({
    filterGroups = [],
    children,
    className = ''
}: FilterSidebarProps) => {
    return (
        <div className={`flex flex-col h-full shadow-xl ${className}`} style={{ boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.1)' }}>
            <div className="flex-1 overflow-y-auto p-3 space-y-4">
                {/* Filter Groups */}
                {filterGroups.map((group, index) => (
                    <div key={index} className="space-y-2">
                        {group.title && (
                            <h3 className="text-xs font-medium text-gray-900 dark:text-white uppercase tracking-wide">
                                {group.title}
                            </h3>
                        )}
                        <div className="space-y-1">
                            {group.children}
                        </div>
                    </div>
                ))}

                {/* Custom children */}
                {children}
            </div>
        </div>
    );
};

export default FilterSidebar;
